const ALLOWED_SCHEMES = ['https:', 'mailto:'];

function getAllowedOrigins(): string[] {
  const origins: string[] = [];
  try {
    const homeUrl = import.meta.env.VITE_HOME_URL;
    if (homeUrl) {
      origins.push(new URL(homeUrl).origin);
    }
  } catch {
    // Invalid VITE_HOME_URL, skip
  }
  try {
    const apiUrl = import.meta.env.VITE_API_BASE_URL;
    if (apiUrl) {
      origins.push(new URL(apiUrl).origin);
    }
  } catch {
    // Invalid VITE_API_BASE_URL, skip
  }
  return origins;
}

export function isAllowedNavigation(url: string): boolean {
  try {
    // Reject strings without an explicit scheme to prevent relative-path resolution
    // e.g. "any-random-string" would otherwise resolve to current origin
    if (!/^[a-zA-Z][a-zA-Z0-9+\-.]*:/.test(url)) return false;
    const parsed = new URL(url);
    if (parsed.protocol === 'mailto:') return true;
    return ALLOWED_SCHEMES.includes(parsed.protocol) &&
           getAllowedOrigins().includes(parsed.origin);
  } catch {
    return false;
  }
}
